/*
 * Copyright (c) 2020 NOOGA DEVELOPMENT, All rights reserved.
 * Author Raman Kremko <raman.kremko@noogadev.com>
 */

import { createAction } from '../../utils/redux-utils';
import {
    StoreCashboxesListDto,
    StoreCashBoxesListFilterParams,
    StoreDetailsDto,
    StoreOnMapResource,
    UpdatedStoreDetailsDto,
    StoreCoordinatesHistoryDto,
    StorePhotoInfoDto,
    SetStorePhotoOnPreviewDto,
    S3Buckets,
    StoreInspectionsHistoryDto,
    StoreInspectionDto,
    StoreCashBoxesIntegrationData,
    StoreIntegrationsData,
    StoreIntegrationsStatusesParams,
} from '../api/stores/storesClientTypings';
import { Notification } from '../../utils/utils';
import {
    AiClassificationsHistoryDto,
    PageQueryParams,
    PeriodQueryParams,
    RegistryTurnoversByCashBoxesDto,
    TurnoversByPeriodEXCELParams,
    TurnoversByPeriodQueryParams,
    TurnoversByPeriodWithParams,
} from '../api/apiCommon.typings';
import { TurnoverReportType } from '../../components/RegistryWidgets/Common/ListTypes';
import { CashBoxesIntegrationStatusesParams, CashBoxesStats } from '../api/cashBoxes/cashBoxesClient.typings';

export enum StoreDetailsActionType {
    OPEN_REGISTRY_STORE_CARD_PAGE = 'RegistryStoreCard/open page',
    EXIT_REGISTRY_STORE_CARD_PAGE = 'RegistryStoreCard/exit page',

    FETCH_STORE_DETAILS_SUCCESS = 'RegistryStoreCard/ fetch store details success',
    UPDATE_STORE_DETAILS = 'RegistryStoreCard/ update store details',
    UPDATE_STORE_DETAILS_SUCCESS = 'RegistryStoreCard/ update store details success',

    FETCH_STORE_CASHBOXES_LIST_SUCCESS = 'RegistryStoreCard/ fetch store cashboxes list success',
    APPLY_CASHBOXES_FILTER = 'RegistryStoreCard/ apply cashboxes list filter',
    APPLY_CASHBOXES_PAGING = 'RegistryStoreCard/ apply cashboxes list paging',

    FETCH_STORE_CARD_DATA_ERROR = 'RegistryStoreCard/ fetch store card data error',
    CHANGE_HISTORY_TAB = 'RegistryStoreCard/ change history tab',

    FETCH_STORE_CASHBOXES_STATS = 'RegistryStoreCard/ fetch store cashboxes statistics',
    FETCH_STORE_CASHBOXES_STATS_SUCCESS = 'RegistryStoreCard/ fetch store cashboxes statistics success',
    FETCH_STORE_CASHBOXES_STATS_ERROR = 'RegistryStoreCard/ fetch store cashboxes statistics error',

    FETCH_COORDINATES_HISTORY = 'RegistryStoreCard/ fetch store coordinates changing history',
    FETCH_COORDINATES_HISTORY_SUCCESS = 'RegistryStoreCard/ fetch store coordinates changing history success',
    FETCH_COORDINATES_HISTORY_ERROR = 'RegistryStoreCard/ fetch store coordinates changing history error',
    DOWNLOAD_COORDINATES_HISTORY = 'RegistryStoreCard/ download store coordinates changing history as excel',
    DOWNLOAD_COORDINATES_HISTORY_SUCCESS = 'RegistryStoreCard/ download store coordinates changing history as excel success',
    DOWNLOAD_COORDINATES_HISTORY_ERROR = 'RegistryStoreCard/ download store coordinates changing history as excel error',

    FETCH_INSPECTIONS_HISTORY = 'RegistryStoreCard/ fetch store inspections history',
    FETCH_INSPECTIONS_HISTORY_SUCCESS = 'RegistryStoreCard/ fetch store inspections history success',
    FETCH_INSPECTIONS_HISTORY_ERROR = 'RegistryStoreCard/ fetch store inspections history error',
    CREATE_INSPECTION = 'RegistryStoreCard/ create inspection',
    CREATE_INSPECTION_SUCCESS = 'RegistryStoreCard/ create inspection success',
    CREATE_INSPECTION_ERROR = 'RegistryStoreCard/ create inspection error',
    CANCEL_INSPECTION = 'RegistryStoreCard/ cancel inspection',
    CANCEL_INSPECTION_SUCCESS = 'RegistryStoreCard/ cancel inspection success',
    CANCEL_INSPECTION_ERROR = 'RegistryStoreCard/ cancel inspection error',
    ASSIGN_INSPECTION = 'RegistryStoreCard/ assign inspection',
    ASSIGN_INSPECTION_SUCCESS = 'RegistryStoreCard/ assign inspection success',
    ASSIGN_INSPECTION_ERROR = 'RegistryStoreCard/ assign inspection error',
    COMPLETE_INSPECTION = 'RegistryStoreCard/ complete inspection',
    COMPLETE_INSPECTION_SUCCESS = 'RegistryStoreCard/ complete inspection success',
    COMPLETE_INSPECTION_ERROR = 'RegistryStoreCard/ complete inspection error',

    CHANGE_INSPECTION_VIEW = 'RegistryStoreCard/ extend or collapse inspection',
    COLLAPSE_ALL_INSPECTIONS_VIEWS = 'RegistryStoreCard/ collapse all inspections',

    SET_TURNOVERS_HIDE_TOGGLE = 'RegistryStoreCard/ set turnovers table hide toggle',
    SET_TURNOVERS_REPORT_TYPE = 'RegistryStoreCard/ set turnovers report type',
    FETCH_STORE_TURNOVERS_BY_PERIOD = 'RegistryStoreCard/ fetch store turnovers by period',
    FETCH_STORE_TURNOVERS_BY_PERIOD_SUCCESS = 'RegistryStoreCard/ fetch store turnovers by period success',
    FETCH_STORE_TURNOVERS_BY_PERIOD_ERROR = 'RegistryStoreCard/ fetch store turnovers by period error',
    COLLAPSE_TURNOVERS_BY_PERIOD = 'RegistryStoreCard/ collapse turnovers by period',
    EXPAND_TURNOVERS_PERIOD = 'RegistryStoreCard/ expand turnovers period',
    DOWNLOAD_TURNOVERS_BY_PERIOD = 'RegistryStoreCard/ download turnovers by period as excel',
    DOWNLOAD_TURNOVERS_BY_PERIOD_SUCCESS = 'RegistryStoreCard/ download turnovers by period as excel success',
    DOWNLOAD_TURNOVERS_BY_PERIOD_ERROR = 'RegistryStoreCard/ download turnovers by period as excel error',

    FETCH_STORE_TURNOVERS_BY_CASHBOXES = 'RegistryStoreCard/ fetch store turnovers by cashboxes',
    FETCH_STORE_TURNOVERS_BY_CASHBOXES_SUCCESS = 'RegistryStoreCard/ fetch store turnovers by cashboxes success',
    FETCH_STORE_TURNOVERS_BY_CASHBOXES_ERROR = 'RegistryStoreCard/ fetch store turnovers by cashboxes error',
    APPLY_TURNOVERS_BY_CASHBOXES_FILTER = 'RegistryStoreCard/ apply filter for turnovers by cashboxes',
    APPLY_TURNOVERS_BY_CASHBOXES_PAGING = 'RegistryStoreCard/ apply paging for turnovers by cashboxes',
    DOWNLOAD_TURNOVERS_BY_CASHBOXES = 'RegistryStoreCard/ download turnovers by cashboxes as excel',
    DOWNLOAD_TURNOVERS_BY_CASHBOXES_SUCCESS = 'RegistryStoreCard/ download turnovers by cashboxes as excel success',
    DOWNLOAD_TURNOVERS_BY_CASHBOXES_ERROR = 'RegistryStoreCard/ download turnovers by cashboxes as excel error',

    DROP_ZONE_TOGGLE = 'RegistryStoreCard/ drop zone toggle',
    FETCH_STORE_PHOTOS_INFO = 'RegistryStoreCard/ fetch store photos info',
    FETCH_STORE_PHOTOS_INFO_SUCCESS = 'RegistryStoreCard/ fetch store photos info success',
    FETCH_STORE_PHOTOS_INFO_ERROR = 'RegistryStoreCard/ fetch store photos info error',

    SET_STORE_PHOTO_ON_PREVIEW = 'RegistryStoreCard/ set store photo on preview',
    SET_STORE_PHOTO_ON_PREVIEW_SUCCESS = 'RegistryStoreCard/ set store photo on preview success',
    SET_STORE_PHOTO_ON_PREVIEW_ERROR = 'RegistryStoreCard/ set store photo on preview error',

    UPLOAD_STORE_PHOTOS = 'RegistryStoreCard/ upload store photos',
    UPLOAD_STORE_PHOTOS_SUCCESS = 'RegistryStoreCard/ upload store photos success',
    UPLOAD_STORE_PHOTOS_ERROR = 'RegistryStoreCard/ upload store photos error',

    DELETE_STORE_PHOTOS = 'RegistryStoreCard/ delete store photo',
    DELETE_STORE_PHOTOS_SUCCESS = 'RegistryStoreCard/ delete store photos success',
    DELETE_STORE_PHOTOS_ERROR = 'RegistryStoreCard/ delete store photos error',

    FETCH_AI_CLASSIFICATIONS_HISTORY_START = 'RegistryStoreCard/ fetch ai classifications history start',
    FETCH_AI_CLASSIFICATIONS_HISTORY_SUCCESS = 'RegistryStoreCard/ fetch ai classifications history success',
    FETCH_AI_CLASSIFICATIONS_HISTORY_ERROR = 'RegistryStoreCard/ fetch ai classifications history error',
    DOWNLOAD_AI_CLASSIFICATIONS_HISTORY_START = 'RegistryStoreCard/ download ai classifications history start',
    DOWNLOAD_AI_CLASSIFICATIONS_HISTORY_SUCCESS = 'RegistryStoreCard/ download ai classifications history success',
    DOWNLOAD_AI_CLASSIFICATIONS_HISTORY_ERROR = 'RegistryStoreCard/ download ai classifications history error',

    APPLY_STORE_CASHBOXES_INTEGRATION_PAGING = 'RegistryStoreCard/ apply store cashboxes integration list paging',
    FETCH_STORE_CASHBOXES_INTEGRATION_DATA_START = 'RegistryStoreCard/ fetch store cashboxes integration start',
    FETCH_STORE_CASHBOXES_INTEGRATION_DATA_SUCCESS = 'RegistryStoreCard/ fetch store cashboxes integration success',
    FETCH_STORE_CASHBOXES_INTEGRATION_DATA_ERROR = 'RegistryStoreCard/ fetch store cashboxes integration error',

    UPDATE_STORE_INTEGRATION_STATUS_START = 'RegistryStoreCard/ change store integration data start',
    UPDATE_STORE_INTEGRATION_STATUS_SUCCESS = 'RegistryStoreCard/ change store integration data success',
    FETCH_STORE_INTEGRATION_DATA_START = 'RegistryStoreCard/ fetch store integration data start',
    FETCH_STORE_INTEGRATION_DATA_SUCCESS = 'RegistryStoreCard/ fetch store integration data success',
    FETCH_STORE_INTEGRATION_DATA_ERROR = 'RegistryStoreCard/ fetch store integration data error',

    UPDATE_STORE_CASHBOXES_INTEGRATION_STATUS = 'RegistryStoreCard/ change store cashboxes integration status',
    UPDATE_STORE_CASHBOXES_INTEGRATION_STATUS_SUCCESS = 'RegistryStoreCard/ change store cashboxes integration status success',
}

export const openRegistryStoreCardAction = (storeTaxNumber: string) =>
    createAction(StoreDetailsActionType.OPEN_REGISTRY_STORE_CARD_PAGE, storeTaxNumber);

export const exitRegistryStoreCardAction = () => createAction(StoreDetailsActionType.EXIT_REGISTRY_STORE_CARD_PAGE);

export const fetchStoreDetailsSuccessAction = (payload: StoreDetailsDto) =>
    createAction(StoreDetailsActionType.FETCH_STORE_DETAILS_SUCCESS, payload);

export const updateStoreDetailsAction = (payload: StoreOnMapResource) =>
    createAction(StoreDetailsActionType.UPDATE_STORE_DETAILS, payload);

export const updateStoreDetailsSuccessAction = (payload: UpdatedStoreDetailsDto) =>
    createAction(StoreDetailsActionType.UPDATE_STORE_DETAILS_SUCCESS, payload);

export const fetchStoreCashBoxesListSuccess = (payload: StoreCashboxesListDto) =>
    createAction(StoreDetailsActionType.FETCH_STORE_CASHBOXES_LIST_SUCCESS, payload);

export const applyCashBoxesPagingAction = (params: PageQueryParams) =>
    createAction(StoreDetailsActionType.APPLY_CASHBOXES_PAGING, params);

export const applyCashBoxesFilterAction = (params: StoreCashBoxesListFilterParams) =>
    createAction(StoreDetailsActionType.APPLY_CASHBOXES_FILTER, params);

export const fetchStoreCardDataErrorAction = (notification: Notification) =>
    createAction(StoreDetailsActionType.FETCH_STORE_CARD_DATA_ERROR, { notification });

//-------------------------------------------------------------------------------------

export const changeHistoryTabAction = (value: number) => createAction(StoreDetailsActionType.CHANGE_HISTORY_TAB, value);

export const fetchStoreCashBoxesStatsAction = () => createAction(StoreDetailsActionType.FETCH_STORE_CASHBOXES_STATS);

export const fetchStoreCashBoxesStatsSuccessAction = (payload: CashBoxesStats) =>
    createAction(StoreDetailsActionType.FETCH_STORE_CASHBOXES_STATS_SUCCESS, payload);

export const fetchStoreCashBoxesStatsErrorAction = (notification: Notification) =>
    createAction(StoreDetailsActionType.FETCH_STORE_CASHBOXES_STATS_ERROR, { notification });

export const fetchCoordinatesHistoryAction = () => createAction(StoreDetailsActionType.FETCH_COORDINATES_HISTORY);

export const fetchCoordinatesHistorySuccessAction = (payload: StoreCoordinatesHistoryDto) =>
    createAction(StoreDetailsActionType.FETCH_COORDINATES_HISTORY_SUCCESS, payload);

export const fetchCoordinatesHistoryErrorAction = (notification: Notification) =>
    createAction(StoreDetailsActionType.FETCH_COORDINATES_HISTORY_ERROR, { notification });

export const downloadCoordinatesHistoryAction = () => createAction(StoreDetailsActionType.DOWNLOAD_COORDINATES_HISTORY);

export const downloadCoordinatesHistorySuccessAction = () =>
    createAction(StoreDetailsActionType.DOWNLOAD_COORDINATES_HISTORY_SUCCESS);

export const downloadCoordinatesHistoryErrorAction = (notification: Notification) =>
    createAction(StoreDetailsActionType.DOWNLOAD_COORDINATES_HISTORY_ERROR, { notification });

//-------------------------------------------------------------------------------------

export const fetchInspectionsHistoryAction = () => createAction(StoreDetailsActionType.FETCH_INSPECTIONS_HISTORY);

export const fetchInspectionsHistorySuccessAction = (payload: StoreInspectionsHistoryDto) =>
    createAction(StoreDetailsActionType.FETCH_INSPECTIONS_HISTORY_SUCCESS, payload);

export const fetchInspectionsHistoryErrorAction = (notification: Notification) =>
    createAction(StoreDetailsActionType.FETCH_INSPECTIONS_HISTORY_ERROR, { notification });

export const createInspectionAction = (comment: string) =>
    createAction(StoreDetailsActionType.CREATE_INSPECTION, comment);

export const createInspectionSuccessAction = (payload: StoreInspectionDto) =>
    createAction(StoreDetailsActionType.CREATE_INSPECTION_SUCCESS, payload);

export const createInspectionErrorAction = (notification: Notification) =>
    createAction(StoreDetailsActionType.CREATE_INSPECTION_ERROR, { notification });

export const cancelInspectionAction = (inspectionId: string) =>
    createAction(StoreDetailsActionType.CANCEL_INSPECTION, inspectionId);

export const cancelInspectionSuccessAction = (inspectionId: string) =>
    createAction(StoreDetailsActionType.CANCEL_INSPECTION_SUCCESS, inspectionId);

export const cancelInspectionErrorAction = (notification: Notification) =>
    createAction(StoreDetailsActionType.CANCEL_INSPECTION_ERROR, { notification });

export const assignInspectionAction = (inspectionId: string) =>
    createAction(StoreDetailsActionType.ASSIGN_INSPECTION, inspectionId);

export const assignInspectionSuccessAction = (payload: StoreInspectionDto) =>
    createAction(StoreDetailsActionType.ASSIGN_INSPECTION_SUCCESS, payload);

export const assignInspectionErrorAction = (notification: Notification) =>
    createAction(StoreDetailsActionType.ASSIGN_INSPECTION_ERROR, { notification });

export const completeInspectionAction = (completeInspectionData: Partial<StoreInspectionDto>) =>
    createAction(StoreDetailsActionType.COMPLETE_INSPECTION, completeInspectionData);

export const completeInspectionSuccessAction = (payload: StoreInspectionDto) =>
    createAction(StoreDetailsActionType.COMPLETE_INSPECTION_SUCCESS, payload);

export const completeInspectionErrorAction = (notification: Notification) =>
    createAction(StoreDetailsActionType.COMPLETE_INSPECTION_ERROR, { notification });

export const changeInspectionViewAction = (viewStatus: { inspectionId: string; isExpanded: boolean }) =>
    createAction(StoreDetailsActionType.CHANGE_INSPECTION_VIEW, viewStatus);

export const collapseAllInspectionsViewsAction = () =>
    createAction(StoreDetailsActionType.COLLAPSE_ALL_INSPECTIONS_VIEWS);
//-------------------------------------------------------------------------------------

export const setTurnoversHideToggleAction = (isToHide: boolean) =>
    createAction(StoreDetailsActionType.SET_TURNOVERS_HIDE_TOGGLE, isToHide);

export const setTurnoversReportTypeAction = (reportType: TurnoverReportType) =>
    createAction(StoreDetailsActionType.SET_TURNOVERS_REPORT_TYPE, reportType);

export const fetchStoreTurnoversByPeriodAction = (payload: TurnoversByPeriodQueryParams) =>
    createAction(StoreDetailsActionType.FETCH_STORE_TURNOVERS_BY_PERIOD, payload);

export const fetchStoreTurnoversByPeriodSuccessAction = (payload: TurnoversByPeriodWithParams) =>
    createAction(StoreDetailsActionType.FETCH_STORE_TURNOVERS_BY_PERIOD_SUCCESS, payload);

export const fetchStoreTurnoversByPeriodErrorAction = (notification: Notification) =>
    createAction(StoreDetailsActionType.FETCH_STORE_TURNOVERS_BY_PERIOD_ERROR, { notification });

export const collapseTurnoversByPeriodAction = () => createAction(StoreDetailsActionType.COLLAPSE_TURNOVERS_BY_PERIOD);

export const expandTurnoversPeriodAction = (payload: { period: string; isToHide: boolean }) =>
    createAction(StoreDetailsActionType.EXPAND_TURNOVERS_PERIOD, payload);

export const downloadTurnoversByPeriodAction = (params: TurnoversByPeriodEXCELParams) =>
    createAction(StoreDetailsActionType.DOWNLOAD_TURNOVERS_BY_PERIOD, params);

export const downloadTurnoversByPeriodSuccessAction = () =>
    createAction(StoreDetailsActionType.DOWNLOAD_TURNOVERS_BY_PERIOD_SUCCESS);

export const downloadTurnoversByPeriodErrorAction = (notification: Notification) =>
    createAction(StoreDetailsActionType.DOWNLOAD_TURNOVERS_BY_PERIOD_ERROR, { notification });

export const fetchStoreTurnoversByCashBoxesAction = () =>
    createAction(StoreDetailsActionType.FETCH_STORE_TURNOVERS_BY_CASHBOXES);

export const fetchStoreTurnoversByCashBoxesSuccessAction = (payload: RegistryTurnoversByCashBoxesDto) =>
    createAction(StoreDetailsActionType.FETCH_STORE_TURNOVERS_BY_CASHBOXES_SUCCESS, payload);

export const fetchStoreTurnoversByCashBoxesErrorAction = (notification: Notification) =>
    createAction(StoreDetailsActionType.FETCH_STORE_TURNOVERS_BY_CASHBOXES_ERROR, { notification });

export const applyTurnoversByCashBoxesPagingAction = (params: PageQueryParams) =>
    createAction(StoreDetailsActionType.APPLY_TURNOVERS_BY_CASHBOXES_PAGING, params);

export const applyTurnoversByCashBoxesFilteringAction = (params: PeriodQueryParams) =>
    createAction(StoreDetailsActionType.APPLY_TURNOVERS_BY_CASHBOXES_FILTER, params);

export const downloadTurnoversByCashBoxesAction = () =>
    createAction(StoreDetailsActionType.DOWNLOAD_TURNOVERS_BY_CASHBOXES);

export const downloadTurnoversByCashBoxesSuccessAction = () =>
    createAction(StoreDetailsActionType.DOWNLOAD_TURNOVERS_BY_CASHBOXES_SUCCESS);

export const downloadTurnoversByCashBoxesErrorAction = (notification: Notification) =>
    createAction(StoreDetailsActionType.DOWNLOAD_TURNOVERS_BY_CASHBOXES_ERROR, { notification });

//---------------------------------------------------------

export const dropZoneToggle = (isOpen: boolean) => createAction(StoreDetailsActionType.DROP_ZONE_TOGGLE, isOpen);

export const fetchStorePhotosInfoAction = (storeTaxNumber: string, bucketName: S3Buckets) =>
    createAction(StoreDetailsActionType.FETCH_STORE_PHOTOS_INFO, { storeTaxNumber, bucketName });

export const fetchStorePhotosInfoSuccessAction = (payload: StorePhotoInfoDto[]) =>
    createAction(StoreDetailsActionType.FETCH_STORE_PHOTOS_INFO_SUCCESS, payload);

export const fetchStorePhotosInfoErrorAction = (notification: Notification) =>
    createAction(StoreDetailsActionType.FETCH_STORE_PHOTOS_INFO_ERROR, { notification });

export const setStorePhotoOnPreviewAction = (params: SetStorePhotoOnPreviewDto[]) =>
    createAction(StoreDetailsActionType.SET_STORE_PHOTO_ON_PREVIEW, params);

export const setStorePhotoOnPreviewSuccessAction = (name: string) =>
    createAction(StoreDetailsActionType.SET_STORE_PHOTO_ON_PREVIEW_SUCCESS, name);

export const setStorePhotoOnPreviewErrorAction = (notification: Notification) =>
    createAction(StoreDetailsActionType.SET_STORE_PHOTO_ON_PREVIEW_ERROR, { notification });

export const uploadStorePhotosAction = (params: StorePhotoInfoDto[], bucketName: S3Buckets) =>
    createAction(StoreDetailsActionType.UPLOAD_STORE_PHOTOS, { params, bucketName });

export const uploadStorePhotosSuccessAction = (payload: StorePhotoInfoDto[]) =>
    createAction(StoreDetailsActionType.UPLOAD_STORE_PHOTOS_SUCCESS, payload);

export const uploadStorePhotosErrorAction = (notification: Notification) =>
    createAction(StoreDetailsActionType.UPLOAD_STORE_PHOTOS_ERROR, { notification });

export const deleteStorePhotosAction = (name: string, addedPhotoUserId: number, bucketName: S3Buckets) =>
    createAction(StoreDetailsActionType.DELETE_STORE_PHOTOS, { name, addedPhotoUserId, bucketName });

export const deleteStorePhotosSuccessAction = (name: string) =>
    createAction(StoreDetailsActionType.DELETE_STORE_PHOTOS_SUCCESS, name);

export const deleteStorePhotosErrorAction = (notification: Notification) =>
    createAction(StoreDetailsActionType.DELETE_STORE_PHOTOS_ERROR, notification);

//---------------------------------------------------------

export const fetchStoreClassificationsHistoryStartAction = (params: PageQueryParams) =>
    createAction(StoreDetailsActionType.FETCH_AI_CLASSIFICATIONS_HISTORY_START, params);

export const fetchStoreClassificationsHistorySuccessAction = (payload: AiClassificationsHistoryDto) =>
    createAction(StoreDetailsActionType.FETCH_AI_CLASSIFICATIONS_HISTORY_SUCCESS, payload);

export const fetchStoreClassificationsHistoryErrorAction = (notification: Notification) =>
    createAction(StoreDetailsActionType.FETCH_AI_CLASSIFICATIONS_HISTORY_ERROR, { notification });

export const downloadStoreClassificationsHistoryAction = () =>
    createAction(StoreDetailsActionType.DOWNLOAD_AI_CLASSIFICATIONS_HISTORY_START);

export const downloadStoreClassificationsHistorySuccessAction = () =>
    createAction(StoreDetailsActionType.DOWNLOAD_AI_CLASSIFICATIONS_HISTORY_SUCCESS);

export const downloadStoreClassificationsHistoryErrorAction = (notification: Notification) =>
    createAction(StoreDetailsActionType.DOWNLOAD_AI_CLASSIFICATIONS_HISTORY_ERROR, { notification });

export const applyStoreCashBoxesIntegrationPagingAction = (params: PageQueryParams) =>
    createAction(StoreDetailsActionType.APPLY_STORE_CASHBOXES_INTEGRATION_PAGING, params);

export const fetchStoreCashBoxesIntegrationDataAction = () =>
    createAction(StoreDetailsActionType.FETCH_STORE_CASHBOXES_INTEGRATION_DATA_START);

export const fetchStoreCashBoxesIntegrationDataSuccessAction = (payload: StoreCashBoxesIntegrationData) =>
    createAction(StoreDetailsActionType.FETCH_STORE_CASHBOXES_INTEGRATION_DATA_SUCCESS, payload);

export const storeCashBoxesIntegrationDataErrorAction = (notification: Notification) =>
    createAction(StoreDetailsActionType.FETCH_STORE_CASHBOXES_INTEGRATION_DATA_ERROR, { notification });

export const changeStoreCashBoxesIntegrationStatus = (payload: CashBoxesIntegrationStatusesParams[]) =>
    createAction(StoreDetailsActionType.UPDATE_STORE_CASHBOXES_INTEGRATION_STATUS, payload);

export const changeStoreCashBoxesIntegrationStatusSuccess = () =>
    createAction(StoreDetailsActionType.UPDATE_STORE_CASHBOXES_INTEGRATION_STATUS_SUCCESS);

export const applyStoreIntegrationsStatusChangesAction = (params: StoreIntegrationsStatusesParams) =>
    createAction(StoreDetailsActionType.UPDATE_STORE_INTEGRATION_STATUS_START, params);

export const applyStoreIntegrationsStatusChangesSuccessAction = (payload: StoreIntegrationsData) =>
    createAction(StoreDetailsActionType.UPDATE_STORE_INTEGRATION_STATUS_SUCCESS, payload);

export const fetchStoreIntegrationsDataAction = () =>
    createAction(StoreDetailsActionType.FETCH_STORE_INTEGRATION_DATA_START);

export const fetchStoreIntegrationsDataSuccessAction = (payload: StoreIntegrationsData) =>
    createAction(StoreDetailsActionType.FETCH_STORE_INTEGRATION_DATA_SUCCESS, payload);

export const fetchStoreIntegrationsDataErrorAction = (notification: Notification) =>
    createAction(StoreDetailsActionType.FETCH_STORE_INTEGRATION_DATA_ERROR, { notification });

export type StoreDetailsActions =
    | ReturnType<typeof openRegistryStoreCardAction>
    | ReturnType<typeof exitRegistryStoreCardAction>
    | ReturnType<typeof fetchStoreDetailsSuccessAction>
    | ReturnType<typeof updateStoreDetailsAction>
    | ReturnType<typeof updateStoreDetailsSuccessAction>
    | ReturnType<typeof fetchStoreCashBoxesListSuccess>
    | ReturnType<typeof applyCashBoxesPagingAction>
    | ReturnType<typeof applyCashBoxesFilterAction>
    | ReturnType<typeof fetchStoreCardDataErrorAction>
    | ReturnType<typeof changeHistoryTabAction>
    | ReturnType<typeof fetchStoreCashBoxesStatsAction>
    | ReturnType<typeof fetchStoreCashBoxesStatsSuccessAction>
    | ReturnType<typeof fetchStoreCashBoxesStatsErrorAction>
    | ReturnType<typeof fetchCoordinatesHistoryAction>
    | ReturnType<typeof fetchCoordinatesHistorySuccessAction>
    | ReturnType<typeof fetchCoordinatesHistoryErrorAction>
    | ReturnType<typeof downloadCoordinatesHistoryAction>
    | ReturnType<typeof downloadCoordinatesHistorySuccessAction>
    | ReturnType<typeof downloadCoordinatesHistoryErrorAction>
    | ReturnType<typeof fetchInspectionsHistoryAction>
    | ReturnType<typeof fetchInspectionsHistorySuccessAction>
    | ReturnType<typeof fetchInspectionsHistoryErrorAction>
    | ReturnType<typeof createInspectionAction>
    | ReturnType<typeof createInspectionSuccessAction>
    | ReturnType<typeof createInspectionErrorAction>
    | ReturnType<typeof cancelInspectionAction>
    | ReturnType<typeof cancelInspectionSuccessAction>
    | ReturnType<typeof cancelInspectionErrorAction>
    | ReturnType<typeof assignInspectionAction>
    | ReturnType<typeof assignInspectionSuccessAction>
    | ReturnType<typeof assignInspectionErrorAction>
    | ReturnType<typeof completeInspectionAction>
    | ReturnType<typeof completeInspectionSuccessAction>
    | ReturnType<typeof completeInspectionErrorAction>
    | ReturnType<typeof changeInspectionViewAction>
    | ReturnType<typeof collapseAllInspectionsViewsAction>
    | ReturnType<typeof setTurnoversHideToggleAction>
    | ReturnType<typeof setTurnoversReportTypeAction>
    | ReturnType<typeof fetchStoreTurnoversByPeriodAction>
    | ReturnType<typeof fetchStoreTurnoversByPeriodSuccessAction>
    | ReturnType<typeof fetchStoreTurnoversByPeriodErrorAction>
    | ReturnType<typeof collapseTurnoversByPeriodAction>
    | ReturnType<typeof expandTurnoversPeriodAction>
    | ReturnType<typeof downloadTurnoversByPeriodAction>
    | ReturnType<typeof downloadTurnoversByPeriodSuccessAction>
    | ReturnType<typeof downloadTurnoversByPeriodErrorAction>
    | ReturnType<typeof fetchStoreTurnoversByCashBoxesAction>
    | ReturnType<typeof fetchStoreTurnoversByCashBoxesSuccessAction>
    | ReturnType<typeof fetchStoreTurnoversByCashBoxesErrorAction>
    | ReturnType<typeof applyTurnoversByCashBoxesPagingAction>
    | ReturnType<typeof applyTurnoversByCashBoxesFilteringAction>
    | ReturnType<typeof downloadTurnoversByCashBoxesAction>
    | ReturnType<typeof downloadTurnoversByCashBoxesSuccessAction>
    | ReturnType<typeof downloadTurnoversByCashBoxesErrorAction>
    | ReturnType<typeof dropZoneToggle>
    | ReturnType<typeof fetchStorePhotosInfoAction>
    | ReturnType<typeof fetchStorePhotosInfoSuccessAction>
    | ReturnType<typeof fetchStorePhotosInfoErrorAction>
    | ReturnType<typeof setStorePhotoOnPreviewAction>
    | ReturnType<typeof setStorePhotoOnPreviewSuccessAction>
    | ReturnType<typeof setStorePhotoOnPreviewErrorAction>
    | ReturnType<typeof uploadStorePhotosAction>
    | ReturnType<typeof uploadStorePhotosSuccessAction>
    | ReturnType<typeof uploadStorePhotosErrorAction>
    | ReturnType<typeof deleteStorePhotosAction>
    | ReturnType<typeof deleteStorePhotosSuccessAction>
    | ReturnType<typeof deleteStorePhotosErrorAction>
    | ReturnType<typeof fetchStoreClassificationsHistoryStartAction>
    | ReturnType<typeof fetchStoreClassificationsHistorySuccessAction>
    | ReturnType<typeof fetchStoreClassificationsHistoryErrorAction>
    | ReturnType<typeof downloadStoreClassificationsHistoryAction>
    | ReturnType<typeof downloadStoreClassificationsHistorySuccessAction>
    | ReturnType<typeof downloadStoreClassificationsHistoryErrorAction>
    | ReturnType<typeof applyStoreCashBoxesIntegrationPagingAction>
    | ReturnType<typeof fetchStoreCashBoxesIntegrationDataAction>
    | ReturnType<typeof fetchStoreCashBoxesIntegrationDataSuccessAction>
    | ReturnType<typeof storeCashBoxesIntegrationDataErrorAction>
    | ReturnType<typeof fetchStoreIntegrationsDataAction>
    | ReturnType<typeof fetchStoreIntegrationsDataSuccessAction>
    | ReturnType<typeof fetchStoreIntegrationsDataErrorAction>
    | ReturnType<typeof applyStoreIntegrationsStatusChangesAction>
    | ReturnType<typeof changeStoreCashBoxesIntegrationStatus>
    | ReturnType<typeof changeStoreCashBoxesIntegrationStatusSuccess>
    | ReturnType<typeof applyStoreIntegrationsStatusChangesSuccessAction>;
